import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  CreateButton,
  TopToolbar,
  DateField,
  BooleanField,
} from 'react-admin';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useNavigate } from 'react-router-dom';
import { CustomEmptyState } from '../../components/CustomEmptyState';
import { PageTitle } from '../../components/PageTitle';

const TimeTrackingActivitiesListActions = () => {
  const navigate = useNavigate();
  return (
    <TopToolbar>
      <CreateButton
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          navigate('/timetracking/activities/create');
        }}
      />
    </TopToolbar>
  );
};

const ConfigurationBreadcrumbs = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 2, backgroundColor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        <Link
          underline="hover"
          component="button"
          variant="body1"
          onClick={() => navigate('/configuration')}
          sx={{ cursor: 'pointer' }}
        >
          Configuration
        </Link>
        <Typography color="text.primary">Time Activities</Typography>
      </Breadcrumbs>
    </Box>
  );
};

export const TimeTrackingActivitiesList = () => {
  const navigate = useNavigate();

  return (
    <>
      <PageTitle title="Time Activities" icon={<AccessTimeIcon />} />
      <List
        title="Time Activities"
        actions={<TimeTrackingActivitiesListActions />}
        sort={{ field: 'name', order: 'ASC' }}
        empty={
          <CustomEmptyState
            resource="timetracking-activities"
            onAction={() => navigate('/timetracking/activities/create')}
          />
        }
      >
        <ConfigurationBreadcrumbs />
        <Datagrid rowClick="edit" bulkActionButtons={false}>
          <TextField source="name" />
          <BooleanField source="isActive" label="Active" />
          <DateField source="createdAt" showTime />
          <DateField source="updatedAt" showTime />
        </Datagrid>
      </List>
    </>
  );
};
